module.exports = __webpack_public_path__ + "static/media/leaderboard-img2.ac0ca8d5.jpeg";